import { Pipe, PipeTransform } from '@angular/core';
import { SubscriptionStatus, SubscriptionStatusTranslations } from 'src/app/core/interfaces/subscription-status.interface';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Pipe({ name: 'subscriptionStatus', pure: false })
export class SubscriptionStatusPipe implements PipeTransform {
    constructor(private localizationService: LocalizationService) { }

    transform(value: SubscriptionStatus | string): string {
        if (!value) return '';
        return this.localizationService.getCachedLanguage() === 'ar'
            ? SubscriptionStatusTranslations[value as SubscriptionStatus] || value
            : value;
    }
}